import { forwardRef, useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import ErrorIcon from '@/assets/icons/common/error.svg';
import X from '@/assets/icons/common/X.svg';
import { useScrollIntoViewOnChange } from '@/hooks/useScrollIntoToView';

export const Error = () => {
  const {
    error,
    actions: { setError },
  } = useContext(CheckoutContext);

  const { ref } = useScrollIntoViewOnChange(error);

  if (!error) return null;

  return <ErrorView ref={ref} message={error} onClose={() => setError(null)} />;
};

interface ErrorViewProps {
  message: string;
  onClose?: () => void;
}

export const ErrorView = forwardRef<HTMLDivElement, ErrorViewProps>(({ message, onClose }, ref) => (
  <div
    ref={ref}
    data-testid="error-inline"
    role="alert"
    className="relative animate-attention w-full bg-white border border-base-border rounded-lg px-4 py-3 animate-in fade-in slide-in-from-bottom-1 duration-300"
  >
    {onClose && (
      <img
        data-testid="error-close-button"
        src={X}
        className="absolute top-2 right-2 w-3.5 h-3.5 cursor-pointer opacity-70"
        onClick={onClose}
      />
    )}
    <div className="flex items-start gap-3 pr-5">
      <img data-testid="error-icon" src={ErrorIcon} className="w-5 h-5 shrink-0 mt-0.5" />
      <div data-testid="error-message" className="text-sm text-base-foreground leading-snug break-words text-left">
        {message}
      </div>
    </div>
  </div>
));

ErrorView.displayName = 'ErrorView';
